import airbridge from 'airbridge-web-sdk-loader';

type DeepLinksParams = {
  [key: string]: string | number | boolean | undefined | null;
};

export const deepLink = (params: DeepLinksParams, path: string = '') => {
  const appDomain = 'app.mindlyspace.com';
  let paramsData = '';

  let i = 0;
  for (const key in params) {
    if (params[key]) {
      paramsData += `${i === 0 ? '?' : '&'}${key}=${params[key]}`;
      i++;
    }
  }

  airbridge.openDeeplink({
    type: 'click',
    deeplinks: {
      ios: `mindly://app/${path}${paramsData}`,
      android: `mindly://app/${path}${paramsData}`,
      desktop: `https://${appDomain}/${path}${paramsData}`,
    },
    fallbacks: {
      ios: 'itunes-appstore',
      android: 'google-play',
    },
  });
};
